<div class="flex h-full flex-row overflow-hidden bg-greyscale-50">
  <app-admin-menu
    class="m-4 flex h-[calc(100%-2rem)] w-[280px] shrink-0 flex-col overflow-hidden rounded-lg bg-white shadow-sm"
  />
  <main class="flex min-w-0 flex-1 flex-col overflow-hidden">
    <p-breadcrumb
      [model]="breadcrumbItems"
      [dt]="breadcrumbTokens"
      class="shrink-0 pt-4 text-xs"
    />
    <div class="flex-1 overflow-y-auto overflow-x-hidden">
      <router-outlet />
    </div>
    <p-confirmdialog />
  </main>
</div>
